import { Menu, Transition } from "@headlessui/react"
import { Fragment } from "react"
import { useTranslation } from "react-i18next"
import { MdLogout } from "react-icons/md"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { navbarItems } from "./helper"

export default function Example({ icon: Icon, onClick }) {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const image = useSelector((state) => state.userDatasReducer.photo)

  return (
    <>
      <Menu as="div" className="relative inline-block text-left">
        <div>
          <Menu.Button className="inline-flex items-center justify-center w-full p-2 text-sm font-medium text-white hover:bg-opacity-30 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75">
            <div className="w-[45px] h-[45px] flex justify-center items-center border rounded-[60px] overflow-hidden">
              {image ? <img src={image} alt="" /> : <Icon size={20} />}
            </div>
            {/* <FiChevronDown
              className="w-5 h-5 ml-2 -mr-1 text-violet-200 hover:text-violet-100"
              aria-hidden="true"
            /> */}
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute right-0 w-56 mt-2 origin-top-right bg-white divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
            <div className="px-1 py-1 ">
              {navbarItems?.map((item, index) => {
                const Icon = item?.icon
                return (
                  <Menu.Item key={index + 1}>
                    {({ active }) => (
                      <button
                        className={`${
                          active
                            ? "bg-[#2D2D2DE5] backdrop-opacity-[4px] text-white"
                            : "text-gray-900"
                        } group flex w-full items-center rounded-md px-2 py-2 text-sm text-[16px]`}
                        onClick={() => navigate(item?.path)}
                      >
                        <Icon className="w-5 h-5 mr-4" aria-hidden="true" />
                        {t(item?.title)}
                      </button>
                    )}
                  </Menu.Item>
                )
              })}
              <Menu.Item>
                {({ active }) => (
                  <button
                    onClick={onClick}
                    className={`${
                      active
                        ? "bg-[#2D2D2DE5] backdrop-opacity-[4px] text-white"
                        : "text-gray-900"
                    } group flex w-full items-center rounded-md px-2 py-2 text-sm text-[16px]`}
                  >
                    <MdLogout className="w-5 h-5 mr-4" aria-hidden="true" />
                    {t("logout")}
                  </button>
                )}
              </Menu.Item>
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </>
  )
}
